import { breakpoints, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import ReactModal from 'react-modal';
import React from 'react';
import { backdropStyles, bodyClassName } from '../utils/overlayStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const drawerStyles = function (shouldOpenHorizontally, backgroundColor) {
  if (backgroundColor === void 0) {
    backgroundColor = vars.colors.page.background.primary;
  }
  return css`
  background-color: ${backgroundColor};
  border-radius: 3px;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  display: flex;
  flex-direction: column;
  height: 100%;
  outline: none;
  position: relative;
  transform: ${shouldOpenHorizontally ? 'translateX(100%);' : 'translateY(100%);'};
  transition: transform 500ms cubic-bezier(0.75, 0, 0.175, 1);
  width: 100%;
  z-index: 1;

  &.ReactModal__Content--after-open {
    transform: ${shouldOpenHorizontally ? 'translateX(0)' : 'translateY(0)'};
  }

  &.ReactModal__Content--before-close {
    transform: ${shouldOpenHorizontally ? 'translateX(100%);' : 'translateY(100%);'};
  }

  @media (max-width: ${breakpoints._768}) {
    [dir='rtl'] & {
      left: 0;
      right: auto;
      transform: translateX(-100%);
    }

    &.ReactModal__Content--after-open {
      transform: ${shouldOpenHorizontally ? 'translateX(0%)' : 'translateY(0)'};
    }

    &.ReactModal__Content--before-close {
      transform: ${shouldOpenHorizontally ? 'translateX(100%);' : 'translateY(100%);'};
      [dir='rtl'] & {
        transform: ${shouldOpenHorizontally ? 'translateX(-100%);' : 'translateY(100%);'};
      }
    }
  }

  @media (min-width: ${breakpoints._768}) {
    bottom: 0;
    max-width: 604px;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    transform: translateX(100%);
    transition: transform 500ms cubic-bezier(0.75, 0, 0.175, 1);
    width: 100%;

    [dir='rtl'] & {
      left: 0;
      right: auto;
      transform: translateX(-100%);
    }

    &.ReactModal__Content--after-open {
      transform: translateX(0%);
    }

    &.ReactModal__Content--before-close {
      opacity: 1;
      transform: translateX(100%);

      [dir='rtl'] & {
        transform: translateX(-100%);
      }
    }
  }
`;
};
const OverlayDrawer = _ref => {
  let {
    backgroundColor,
    children,
    className,
    contentLabel,
    dataTestId,
    handleClose,
    id,
    isOpen,
    shouldOpenHorizontally = false,
    shouldPreventScroll,
    shouldCloseOnOverlayClick = true
  } = _ref;
  const handleAfterClose = () => {
    document.body.classList.remove(bodyClassName);
  };
  return /*#__PURE__*/_jsx(ReactModal, {
    appElement: document.querySelector('#root'),
    aria: {
      labelledby: 'modal-title'
    },
    bodyOpenClassName: bodyClassName,
    className: cx(className, drawerStyles(shouldOpenHorizontally, backgroundColor)),
    closeTimeoutMS: 500,
    contentLabel: contentLabel,
    id: id,
    isOpen: isOpen,
    onAfterClose: handleAfterClose,
    onRequestClose: handleClose,
    overlayClassName: backdropStyles,
    preventScroll: shouldPreventScroll,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    testId: dataTestId,
    children: children
  });
};
export default OverlayDrawer;
//# sourceMappingURL=OverlayDrawer.js.map